import states from './MYStates'

export default {
   "type": "object",
   "required": [
      "fullname", "icpassport", "contactemail", "contactmobile", "homestate", "membertype", "memberstatus", "password"
   ],
   "properties": {
      "salutation": {
         "type": "string",
         "title": "Salutation",
         "default": "",
         "x-props": {
            "dense": true,
         }
      },
      "fullname": {
         "type": "string",
         "title": "Full Name",
         "default": "",
         "x-props": {
            "dense": true,
         }
      },
      "icpassport": {
         "type": "string",
         "title": "IC / Passport No.",
         "default": "",
         "x-props": {
            "dense": true,
         }
      },
      "memberid": {
         "type": "string",
         "title": "Member ID",
         "default": "",
         "x-props": {
            "dense": true,
         }
      },
      "contactemail": {
         "type": "string",
         "title": "Email",
         "pattern": ".+@.+\\..+",
         "default": "",
         "x-options": {
            "messages": {
              "pattern": "Must be a valid email"
            }
          },
      },
      "contactmobile": {
         "type": "string",
         "title": "Mobile No.",
         "default": "",
         "x-props": {
            "dense": true,
         }
      },
      "homestate": {
         "type": "string",
         "title": "Home State / Region",
         "default": "",
         "oneOf": states.map(state => ({
            "const": state.const,
            "title": state.title
         })),
         "x-props": {
            "dense": true,
            "hint": "Required for membership zone, nomination and election access.",
            "persistent-hint": true
         }
      },
      "membertype": {
         "type": "string",
         "title": "Membership Type",
         "default": "",
         "oneOf": [
            {
               "const": "ASC",
               "title": "Associate Member",
            },
            {
               "const": "STU",
               "title": "Student Member",
            },
            {
               "const": "GRA",
               "title": "Graduate Member",
            },
            {
               "const": "COR",
               "title": "Corporate Member",
            },
            {
               "const": "FEL",
               "title": "Fellow Member",
            },
            {
               "const": "HON",
               "title": "Honorary Member",
            },
            {
               "const": "PAT",
               "title": "Patron",
            },
         ],
      },
      "memberstatus": {
         "type": "number",
         "title": "Membership Status",
         "default": 3,
         "oneOf": [
            {
               "const": 0,
               "title": "Applying",
            },
            {
               "const": 1,
               "title": "Pending Approval",
            },
            {
               "const": 2,
               "title": "Pending Payment",
            },
            {
               "const": 3,
               "title": "Active",
            },
            {
               "const": 4,
               "title": "Suspended",
            },
            {
               "const": 5,
               "title": "Retired",
            },
            {
               "const": 6,
               "title": "Deceased",
            },
            {
               "const": 7,
               "title": "Struck-Off",
            },
            {
               "const": 8,
               "title": "Non-Good Standing",
            },
         ],
      },
      "password": {
         "type": "string",
         "title": "Password",
         "default": "",
         "minLength": 8,
         "x-props": {
            "dense": true,
            "type": "password"
         },
         "x-options": {
            "messages": {
               "minLength": "Password must be at least 8 characters"
            }
         }
      },
   }
}
